var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import classNames from "classnames";
import { Heading, Link, TextPlaceholder, BasePlaceholder, Picture, PicturePlaceholder } from "@riseart/common";
import { splitName } from "@riseart/fe-utils";
import { cardArtistCls, cardArtistStyle1Cls, cardArtistStyle2Cls, cardArtistBodyCls, cardArtistImageCls, cardArtistDetailsCls, cardArtistTitleCls, cardArtistInfoCls, cardArtistFooterCls } from "./Artist.less";
function ArtistCard(_ref) {
  var _ref$displayStyle = _ref.displayStyle, displayStyle = _ref$displayStyle === void 0 ? "1" : _ref$displayStyle, _ref$placeholder = _ref.placeholder, placeholder = _ref$placeholder === void 0 ? false : _ref$placeholder, name = _ref.name, url = _ref.url, pictureProps = _ref.pictureProps, infoItems = _ref.infoItems, footer = _ref.footer, _ref$showImagePlaceho = _ref.showImagePlaceholder, showImagePlaceholder = _ref$showImagePlaceho === void 0 ? false : _ref$showImagePlaceho;
  var STYLE_TO_SETTINGS = {
    "1": {
      className: [cardArtistStyle1Cls],
      showFooter: true
    },
    "2": {
      className: [cardArtistStyle2Cls],
      showFooter: true
    }
  };
  var _ref2 = STYLE_TO_SETTINGS[displayStyle] || STYLE_TO_SETTINGS["1"], displayClassName = _ref2.className;
  var _splitName = splitName(name), firstName = _splitName.firstName, lastName = _splitName.lastName;
  var PictureComponent = showImagePlaceholder ? PicturePlaceholder : Picture;
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames(cardArtistCls, displayClassName)
  }, /* @__PURE__ */ React.createElement("div", {
    className: cardArtistBodyCls
  }, /* @__PURE__ */ React.createElement("div", {
    className: cardArtistImageCls
  }, placeholder ? /* @__PURE__ */ React.createElement(BasePlaceholder, null) : /* @__PURE__ */ React.createElement(Link, {
    to: url,
    title: name
  }, pictureProps ? /* @__PURE__ */ React.createElement(PictureComponent, pictureProps) : /* @__PURE__ */ React.createElement(BasePlaceholder, null))), /* @__PURE__ */ React.createElement("div", {
    className: cardArtistDetailsCls
  }, /* @__PURE__ */ React.createElement(Heading, {
    tag: "h3",
    level: "3",
    className: cardArtistTitleCls,
    placeholder
  }, /* @__PURE__ */ React.createElement(Link, {
    to: url,
    title: name
  }, firstName && /* @__PURE__ */ React.createElement("span", null, firstName, " ") || null, lastName && /* @__PURE__ */ React.createElement("span", null, lastName) || null)), !placeholder && infoItems && infoItems.length ? /* @__PURE__ */ React.createElement("div", {
    className: cardArtistInfoCls
  }, infoItems.map(function(infoItem, idx) {
    return /* @__PURE__ */ React.createElement("div", {
      key: idx
    }, infoItem);
  })) : placeholder && /* @__PURE__ */ React.createElement(TextPlaceholder, null) || null)), footer ? /* @__PURE__ */ React.createElement("div", {
    className: cardArtistFooterCls
  }, footer) : null);
}
__name(ArtistCard, "ArtistCard");
export {
  ArtistCard
};
